import React from 'react';

function PrivacyPolicy() {
  return (
    <div className="page-container">
      <h2>Privacy Policy for Tiny Podcasts</h2>
      <p>Last Updated: 19th March 2025</p>
      <h3>Introduction</h3>
      <p>
      Tiny Software, registered at Großklein 12, Austria ("we", "us", or "our") operates the Tiny Podcasts Chrome extension (the "Extension"). This Privacy Policy informs you about how we collect, use, and process your personal data when you use our Extension, and your rights regarding your personal data in accordance with the General Data Protection Regulation (GDPR) and the Austrian Data Protection Act (Datenschutzgesetz).
      </p>

      <h3>Data Controller</h3>
      <p>
        Tiny Software (Lukas Moro)<br />
        Grossklein 12<br />
        8452 Grossklein<br />
        Austria<br /><br />
        Email: lukas.moro@me.com<br />
        Phone: +436649288857<br />
      </p>

      <h3>Information We Collect</h3>
      <p>Our Extension collects the following information through Google Analytics 4:</p>
      <ul>
        <li>Usage Data: Information about your interactions with the Extension, including storage changes, podcast data, content interactions, features used, and time spent using the Extension.</li>
        <li>Technical Data: Information about your device, browser type and version, time zone setting, browser plug-in types and versions, and operating system.</li>
        <li>Event Data: Records of specific actions you take within the Extension, such as playing podcasts, saving favorites, and adjusting settings.</li>
      </ul>

      <h3>Use of Google Analytics 4</h3>
      <p>
        We use Google Analytics 4 (GA4) to analyze Extension usage and improve our services. Google Analytics 4 is a web analytics service provided by Google Ireland Limited ("Google").
      </p>
      <p>
        Google Analytics 4 uses various identification methods, including first-party cookies, to collect information about your use of our Extension. The information generated will be transmitted to and stored by Google on servers which may be located in the United States or other countries outside the European Economic Area.
      </p>
      <p>
        Google will use this information on our behalf to evaluate your use of the Extension, compile reports on Extension activity, and provide other services relating to Extension activity and internet usage. Google may also transfer this information to third parties where required to do so by law, or where such third parties process the information on Google's behalf.
      </p>
      <p>
        Google Analytics 4 data is retained for a period of 14 months unless otherwise configured.
      </p>

      <h3>Legal Basis for Processing</h3>
      <p>We process your personal data on the following legal bases:</p>
      <ul>
        <li>Consent (Art. 6(1)(a) GDPR): We collect and process your data based on your explicit consent, which you provide by accepting our cookie banner when first using the Extension.</li>
        <li>Legitimate Interest (Art. 6(1)(f) GDPR): We have a legitimate interest in analyzing how our Extension is used to improve its functionality and user experience.</li>
      </ul>

      <h3>Your Rights</h3>
      <p>Under the GDPR and Austrian Data Protection Act, you have the following rights:</p>
      <ul>
        <li>Right to access: You can request information about your personal data that we process.</li>
        <li>Right to rectification: You can request correction of inaccurate data or completion of incomplete data.</li>
        <li>Right to erasure: You can request deletion of your personal data under certain circumstances.</li>
        <li>Right to restriction of processing: You can request restriction of processing under certain circumstances.</li>
        <li>Right to data portability: You can request to receive your personal data in a structured, commonly used, and machine-readable format.</li>
        <li>Right to object: You can object to the processing of your personal data under certain circumstances.</li>
        <li>Right to withdraw consent: You can withdraw your consent at any time.</li>
      </ul>
      <p>To exercise these rights, please contact us using the contact details provided above.</p>

      <h3>Opt-Out Options</h3>
      <p>You can opt out of Google Analytics tracking within our Extension by:</p>
      <ul>
        <li>Adjusting the Extension settings: Go to Settings {'>'}  Privacy and toggle "Disable Analytics"</li>
        <li>Installing the Google Analytics Opt-out Browser Add-on: https://tools.google.com/dlpage/gaoptout</li>
        <li>Disabling cookies in your browser settings</li>
      </ul>

      <h3>International Data Transfers</h3>
      <p>
        Google Analytics 4 may transfer your data to servers located outside the European Economic Area (EEA), including in the United States. Such transfers are safeguarded by Standard Contractual Clauses approved by the European Commission.
      </p>

      <h3>Data Security</h3>
      <p>
        We implement appropriate technical and organizational measures to protect your personal data against accidental or unlawful destruction, loss, alteration, unauthorized disclosure, or access.
      </p>

      <h3>Changes to This Privacy Policy</h3>
      <p>
        We may update this Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page and updating the "Last Updated" date.
      </p>

      <h3>Complaints</h3>
      <p>
        If you believe that our processing of your personal data infringes data protection laws, you have the right to lodge a complaint with the Austrian Data Protection Authority (Datenschutzbehörde):
      </p>
      <p>
        Austrian Data Protection Authority<br />
        Barichgasse 40-42<br />
        1030 Vienna<br />
        Austria<br />
        Phone: +43 1 52 152-0<br />
        Email: dsb@dsb.gv.at<br />
        Website: www.dsb.gv.at
      </p>

      <h3>Contact Us</h3>
      <p>
        If you have any questions about this Privacy Policy or our data practices, please contact us using the contact details provided above.
      </p>
    </div>
  );
}

export default PrivacyPolicy; 